import { DataBean } from "../DataBean";

export class PortfolioProduct extends DataBean {

  public async getPortfolioProductCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getPortfolioProductCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async updatePortfolioProduct(bean: Record<string, any>): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.PortfolioProduct_updatePortfolioProduct_com.orange.finance.processcontract.bean.PortfolioProduct",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.PortfolioProduct",
        },
      ]
    );
  }
}
